import { Box, Button, chakra } from "@chakra-ui/react";

export const SelectedButton = chakra(Button, {
  baseStyle: {
    backgroundColor: "#1819B4",
    color: "#fff",
    padding: "4px 10px 4px 12px",
    gap: "4px",
    borderRadius: "16px",
    height: "auto",
    width: "auto",
    fontWeight: 500,
    fontSize: "14px",
    lineHeight: "20px",
  },
});

export const SelectedButtonBox = chakra(Box, {
  baseStyle: {
    display: "flex",
    gap: "16px",
    flexDirection: "row",
  },
});
